export { InformationWindow as default } from "./InformationWindow";
